import Profil from '../components/profil/profil';
import Header from '../components/header/header';
import SkillsSection from '../components/skills/skills';
import AppointmentForm from '../components/form/form';
import PortfolioProject from '../components/project/project';
import CvDownload from '../components/cv/cv';
import Feedback from '../components/feedback/feedback';
import Footer from '../components/footer/footer';
import React, { useRef, useEffect, forwardRef } from 'react';
import './ScrollEffects.css';
import './a-header.css'
// Créez des composants wrapper avec forwardRef
const ScrollableSection = forwardRef(({ children, className = '' }, ref) => (
  <section ref={ref} className={`${className} item`}>
    {children}
  </section>
));

function Homes() {
  const itemsRef = useRef([]);

  useEffect(() => {
    const currentItems = itemsRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          entry.target.classList.toggle('visible', entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    currentItems.forEach(item => item && observer.observe(item));

    return () => {
      currentItems.forEach(item => item && observer.unobserve(item));
    };
  }, []);

  const addToRefs = (el) => {
    if (el && !itemsRef.current.includes(el)) {
      itemsRef.current.push(el);
    }
  };

  return (
    <div>
      <Header />
      
      <ScrollableSection ref={addToRefs}>
        <Profil />
      </ScrollableSection>

      <ScrollableSection ref={addToRefs}>
        <SkillsSection />
      </ScrollableSection>

      <ScrollableSection ref={addToRefs}>
        <PortfolioProject />
      </ScrollableSection>
          <a href='/#header' className='a-header' > <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADH0lEQVR4nO2aSU8UURCA++Ry0GjidtODB2NEnFfjEqPxYjQmGj0K/gaD8V+4JU4kQD3GkHj0qOPCPyDEswwwJ9wCQlcxeAAxjKnpGVCnp6eX14uESiq8zHT31EfVq1f1XlvWlmxS6RrgvYB0CzQ/UkhvFFIZNNuAtFJXGWuakO/kGtD2ze4R2mNlQY4WatuV5jugaVQh/QLNtSDq3EPvALlXnmUlLeeezOwETfcB+UtQ4z30s9J079JIbUciEHlcvAaaKgYB/lakaaX5amwA4nrQVIgN4N+w0/RCPG8U4uzw0kFA/pAUBGzAjJ8cWDpgBKJ7kI6Iu5OGgHWlKbEhEsSp59X9jTSaEgQ3YSqn+38cCgUh2SONcAKPMAuVohXSYNrGQyvMsxApNn3DwU2Rr/hfrZEmswtC074WzfqKnbaxukOIod3X0RtSKmQfhD95TnynAEzfUPCnPV5hNWr2x2hWDTPkhjgvY6Ne0fS2bT8RphT3gsgXF040ny9jkzBK0+qZwvzuVm84TZFxCPn759gkTG7IvuESVvw4DgjHcLfPDPwW8sPWie60oBEfTHOAdpfj4eoxpelbu+9A01cDIK/cJvqUeU+EuYb9zxOksptHFmLxRIdrI3kGac5tsq/EDmEchpbNgISBMApDy9FDKwqEKRh0Ca2gFa+s2GYm7UYCyNUrgED3TrhlrVKw/4Z9wVzpQbPyLKXtiwbSr2xjRjUoWVWaH8RcoiQFsni9BUQ2lM0WjXEr/XQtGhteef8fgZRcIRwQ7k3fQPaleeTbm6LVPf6yts3yEtnaT9tQ6Kx3PSGaXsnGNim3UZryveMo5xPpG8ytirSWR75sBRFA6k/dcN2iTwNBrIeYpvEMhdRYxwne3ivVfdmYL1SRwyYr8kFP5DY4vCqkyVzRPmyZEDn+SifMaEwOm6xYDkOR1hKBQMZYz97lfCLOUFNI5cApNqw4i6bdJ6WCOQCekRU7lTcgGrVZT/3dE02rgY2v30MlKQBDp1bTIr2B7MXKNiYgva6/QKNpvvlSTWP8UdpT6eykKTpf/L7LuCFbYmVDfgP+oeY+ucVj4AAAAABJRU5ErkJggg==" alt="circled-chevron-up" /></a>
      <ScrollableSection ref={addToRefs}>
        <AppointmentForm />
      </ScrollableSection>

      <ScrollableSection ref={addToRefs}>
        <Feedback />
      </ScrollableSection>

      <div>
        <CvDownload />
      </div>
  
      <Footer />
    </div>
  );
}

export default Homes;